import { ActionCreator } from "redux";
import {
    CloseErrorPopupAction,
    ShowErrorUpdateMessageAction
} from "./type";
import {
    SHOW_ERROR_UPDATE_MESSAGE,
    CLOSE_ERROR_POPUP
} from "./constant";
import { ErrorCodes } from "../../dtos/KioskDtos.dtos";

/**
 * @name closeErrorPopup
 * @constructs CloseErrorPopupAction
 * @param show
 */
export const closeErrorPopup: ActionCreator<CloseErrorPopupAction> = () => ({
    type: CLOSE_ERROR_POPUP
});

/**
 * @name showErrorUpdateMessage
 * @constructs ShowErrorUpdateMessageAction
 * @param show
 * @param errorCode
 * @param returnToMainScreen
 */
export const showErrorUpdateMessage: ActionCreator<ShowErrorUpdateMessageAction> = (
    show: boolean,
    errorCode: ErrorCodes,
    returnToMainScreen: boolean
) => ({
    type: SHOW_ERROR_UPDATE_MESSAGE,
    payload: {
        show,
        errorCode,
        returnToMainScreen
    }
});



// WEBPACK FOOTER //
// ./src/store/Errors/actions.ts